import { f as t } from "./fails.js";
var o = !t(function () {
  function t() {}
  return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
});
export { o as c };